import { Slide } from '@features/powerpoint';
import {
  MinimalCpgDimension,
  DIMENSION_COUNT,
  dimensionSlide,
  DimensionSlideProps,
} from './dimension-slide';
import { CpgDimension } from '@features/campaigns/subdomains/cpg';
import { apiSlugToDimensionName } from '@components/Dashboard/dashboardSlice/responseMappers/dimensionStats';
import { sortBy } from '@utils/arrays';

export type DimensionSlidesProps = {
  slideMaster: string;
  dimensions: (MinimalCpgDimension & Pick<CpgDimension, 'dimensionName'>)[];
  customHeaders: Record<string, string | undefined>;
  excludedColumns: DimensionSlideProps['excludedColumns'];
};

export const dimensionSlides = (props: DimensionSlidesProps): Slide[] => {
  const dimensionsByDimensionName = props.dimensions.reduce(
    (acc, dimension) => {
      acc[dimension.dimensionName] ??= [];
      acc[dimension.dimensionName] = [
        ...acc[dimension.dimensionName],
        dimension,
      ];
      return acc;
    },
    {} as Record<string, MinimalCpgDimension[]>
  );

  return Object.keys(dimensionsByDimensionName).flatMap(dimensionName => {
    const dimensions = dimensionsByDimensionName[dimensionName].toSorted(
      sortBy('salesLiftIndex', 'desc')
    );
    const slideCount = Math.ceil(dimensions.length / DIMENSION_COUNT);
    const header =
      props.customHeaders[dimensionName] ??
      `Sales Summary Table - By ${apiSlugToDimensionName[dimensionName as keyof typeof apiSlugToDimensionName] ?? dimensionName}`;
    return Array.from({ length: slideCount }, (_, index) => {
      const start = index * DIMENSION_COUNT;
      const end = start + DIMENSION_COUNT;
      const currentDimensions = dimensions.slice(start, end);
      return dimensionSlide({
        slideMaster: props.slideMaster,
        title: `${header} (${index + 1}/${slideCount})`,
        dimensions: currentDimensions,
        excludedColumns: props.excludedColumns,
      });
    });
  });
};
